import { computed, makeObservable, observable } from 'mobx';

import { assignModel } from '@/common/helpers/assignModel';

class LoadingTaskModel {
  id!: string;
  title!: string;
  done!: number;
  total!: number;
}

export default class LoadingTask extends LoadingTaskModel {
  declare id: string;

  declare title: string;

  declare done: number;

  declare total: number;

  constructor(modelData: LoadingTaskModel) {
    super();

    makeObservable(this, {
      id: observable,
      title: observable,
      done: observable,
      total: observable,
      percentageOfCompletion: computed,
      isCompleted: computed,
    });

    assignModel<LoadingTaskModel>(this, modelData);
  }

  get percentageOfCompletion() {
    return (this.done / this.total) * 100;
  }

  get isCompleted() {
    return this.percentageOfCompletion === 100;
  }
}
